/* eslint-disable */
import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Popover,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';

const FilterComponent = ({
  resultCount,
  selectedFilters,
  anchorEl,
  open,
  // Nested category → type structure: [{ id, categoryName, types: [{ id, typeName }] }]
  filtersGrouped,
  onFilterClick,
  onFilterClose,
  onFilterSelection,
  onResetFilters,
  onFilterResultClick,
  calculatePotentialResultCount,
  // Optional: title shown in the filter popover header (default: "Filters")
  title,
  // Optional: show loader overlay on "See Results" button
  isLoading,
  // Optional: disable footer buttons when no filters are available
  hasNoFilters,
  // Optional: show spinner inside "See Results" while computing count
  showPreviewCountLoader,
}) => {
  return (
    <Box className="AmenitiesFilterBox">
      <Typography variant="body1" component="div" className="LightgreyColor">
        {`${resultCount} Result${resultCount === 1 ? '' : 's'}`}
      </Typography>
      <Button
        className="SearchButton"
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={onFilterClick}
        startIcon={<FilterListIcon color="primary" />}
        variant="outlined"
      >
        {selectedFilters.length > 0
          ? selectedFilters.length > 1
            ? `Filters(${selectedFilters.length})`
            : `Filter(${selectedFilters.length})`
          : 'Filter'}
        <Box className="FilterCount" component="span"></Box>
      </Button>
      <Popover
        id="long-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={onFilterClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className="MobileFilter"
      >
        <Paper className="CommonFilterBox AmenityFilters">
          <Box className="FilterHeader">
            <Typography variant="h4">{title || 'Filters'}</Typography>
            <CloseIcon color="primary" className="CloseButton" onClick={onFilterClose} />
          </Box>
          <Box className="FilterBody">
            {!filtersGrouped || !filtersGrouped.length ? (
              <Box className="FiltersSection" style={{ padding: '16px', textAlign: 'center' }}>
                <Typography variant="body2" color="textSecondary">
                  No filters found
                </Typography>
              </Box>
            ) : (
              filtersGrouped
                .filter((category) => category?.types?.length > 0)
                .map((category) => (
                  <Box className="FiltersSection" key={category?.id || category?.categoryId}>
                    <Typography variant="body2" component="div" className="FiltersSectionHeading">
                      {category?.categoryName}
                    </Typography>
                    <Box className="FiltersOptionBox">
                      <Box className="FilterTagContent">
                        {category?.types?.map((type) => (
                          <Button
                            key={type.id}
                            className={`FilterTag ${
                              selectedFilters.includes(type.typeName) ? 'selected' : ''
                            }`}
                            onClick={() => onFilterSelection(type.typeName)}
                          >
                            {type.typeName}
                          </Button>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                ))
            )}
          </Box>
          <Box className="FilterFooter">
            <Divider />
            <Box className="FilterAction">
              <Button
                variant="outlined"
                size="small"
                onClick={onResetFilters}
                disabled={!!hasNoFilters || selectedFilters.length === 0}
              >
                Reset Filters
              </Button>
              {!isLoading ? (
                <Button
                  onClick={onFilterResultClick}
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={
                    showPreviewCountLoader || !!hasNoFilters || selectedFilters.length === 0
                  }
                  startIcon={
                    showPreviewCountLoader ? <CircularProgress size={14} color="inherit" /> : null
                  }
                >
                  {showPreviewCountLoader
                    ? ''
                    : selectedFilters.length > 0
                    ? `See [${calculatePotentialResultCount(selectedFilters)}] Results`
                    : 'See Results'}
                </Button>
              ) : (
                ''
              )}
            </Box>
          </Box>
        </Paper>
      </Popover>
    </Box>
  );
};

export default FilterComponent;
